module.exports = __webpack_public_path__ + "static/media/Star fill.cc10b5fe.svg";